import { render, staticRenderFns } from "./SelectSchoolDlg.vue?vue&type=template&id=49feed8c&scoped=true"
import script from "./SelectSchoolDlg.vue?vue&type=script&lang=js"
export * from "./SelectSchoolDlg.vue?vue&type=script&lang=js"
import style0 from "./SelectSchoolDlg.vue?vue&type=style&index=0&id=49feed8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49feed8c",
  null
  
)

export default component.exports